import { useEffect } from 'react'
import { useCart } from 'public/components/online_ordering/CartContext'
import { getEcommShippingFee } from 'public/components/default_template/online_ordering/cart/cartUtils'

/**
 * Hook to automatically delete shipping rate from cart
 * Used when switching between delivery and pickup to ensure shipping rates are cleared
 */
export const useDeleteShippingRate = () => {
  const { cart, deleteFromCart } = useCart()

  useEffect(() => {
    const selectedShippingRate = getEcommShippingFee(cart)?.guid

    if (selectedShippingRate) {
      deleteFromCart(selectedShippingRate)
    }
  }, [cart, deleteFromCart])
}
